const DELIVERYMAN_APPROVAL_MODAL = {
  modalTitle: 'Aprove Entregadores',
  documentInputLabel: 'Encontre um entregador por CPF',
  confirmationButtonLabel: 'Procurar',
  submitButtonLabel: 'Adicionar Entregador',
  approvalFeedback: {
    OPERATIONAL: {
      title: 'Este CPF já foi aprovado!',
    },
    NEW: {
      title: 'Nova pessoa entregadora adicionada!',
    },
  },
  validation: {
    invalid: 'O CPF não é válido',
    required: 'Insira um número de CPF',
    minLength: 'O CPF precisa ter 11 dígitos',
  },
  errors: {
    default: 'Nenhum resultado para o CPF pesquisado.',
  },
  fleetManagementText: {
    modalTitle: 'Adicione sua frota',
    submitButton: 'Aprovar',
    checkDeliveryman: 'Confirme os dados da pessoa entregadora',
    documentInputLabel: 'Insira o CPF da pessoa',
    paymentModelCreated: 'criado',
  },
}

export default DELIVERYMAN_APPROVAL_MODAL
